import React, { useState } from 'react';
import './style/main.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  useLocation,
} from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import PageSEO from './components/PageSEO';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Contacts from './pages/Contacts';
import Project from './pages/Project';
import ScrollToTop from './utils/scrollToTop';
import Gallery from './pages/Gallery';
import MobileNav from './components/mobileNav/MobileNav';
import PricePage from './pages/PricePage';
import PackagePage from './pages/PackagePage';
import DesignPage from './pages/DesignPage';

const NotFound = () => (
  <main style={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.5rem', padding: '4rem 2rem', textAlign: 'center' }}>
    <PageSEO title="404 — Page Not Found | PixelCraft" path="/404" />
    <h1 style={{ fontSize: '5rem', fontWeight: 700, margin: 0, opacity: 0.15 }}>404</h1>
    <p style={{ fontSize: '1.1rem', color: 'var(--text-secondary)' }}>Page not found</p>
    <NavLink to="/" className="button">Go Home</NavLink>
  </main>
);

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Home />
            </motion.div>
          }
        />

        <Route
          path="/prices"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <PricePage />
            </motion.div>
          }
        />

        <Route
          path="/package/:slug"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <PackagePage />
            </motion.div>
          }
        />
        <Route
          path="/care-plan/:slug"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <PackagePage />
            </motion.div>
          }
        />

        <Route
          path="/projects"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Projects />
            </motion.div>
          }
        />
        <Route
          path="/project/:id"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Project />
            </motion.div>
          }
        />
        <Route
          path="/design"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <DesignPage />
            </motion.div>
          }
        />
        <Route
          path="/gallery"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Gallery />
            </motion.div>
          }
        />
        <Route
          path="/contacts"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Contacts />
            </motion.div>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [navOpen, setNavOpen] = useState(false);

  const openNav = () => setNavOpen(true);
  const closeNav = () => setNavOpen(false);

  return (
    <HelmetProvider>
      <div className="App">
        <Router>
          <ScrollToTop />
          <Navbar openNav={openNav} />
          <MobileNav navOpen={navOpen} closeNav={closeNav} />
          <AnimatedRoutes />
          <Footer />
        </Router>
      </div>
    </HelmetProvider>
  );
}

export default App;
